import { RootState } from "../../index";

export const contactListStore = (state: RootState) => state.contact.data;
export const allContactListData = (state: RootState) => state.contact.data.allContactListData;
export const isLoading = (state: RootState) => state.contact.loading;
export const allVisibleContactPropertiesData = (state: RootState) => state.contact.data.allVisibleContactPropertiesData
export const contactListSegStore = (state: RootState) => state.contact.data.allContactfieldsData;
export const getAllFieldsOptions = (state: RootState) => state.contact.data.allFieldsOptions;
